var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  fill: "#979797",
  viewBox: "0 0 16 15",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.651.449 12.02 12.02-1.201 1.203L1.449 1.65z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.551 1.651-12.02 12.02-1.203-1.201L13.35.449z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgXDisabled);
export default ForwardRef;